
































































































































































































































































































































































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
/* api */
import FieldOrderEditApi from '@/app/model/api/fieldOrderEditApi'
/* module */
import Local from '@/app/module/local'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag, userType, harvestStatus } from '@/app/model/store/domain/const'
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import DateClass from '@/app/module/date'
import RiskFunction from '@/app/module/risk'

@Component({
  components: {
    Datepicker
  }
})
export default class OrderList extends Vue {
  private isActive: boolean = true
  private isActiveStatus: boolean = false
  private toggle: boolean = false
  private showDialog: boolean = false
  private gradeList: Array<{[key:string]: string|number}> = []
  private beforeChangeStatus: number = 0
  private afterChangeStatus: number = 0
  private beforeChangeHarvestActualDate: any
  private afterChangeHarvestActualDate: any
  private changeTarget: string = ''
  /* datepicker */
  private japanese: any = ja
  private form: any = 'yyyy-MM-dd'

  @Prop() private orderData!: any
  @Prop() private orderKey!: string
  @Prop() private changeStatusCheck!: number

  @Watch('changeStatusCheck')
  onIdChange (fieldId: number) {
    if (fieldId !== 0 && this.orderData.field_id === fieldId) {
      const bodyData = {
        'harvest_status': this.afterChangeStatus,
        'harvest_actual_date': null,
        'time_stamp': this.orderData.time_stamp
      }
      this.updateStatus(this.orderData.planting_harvest_instruction_id, bodyData)

      // flagをリセットする
      this.$emit('show-status-change-modal', 0)
    }
  }

  created () {
    // 初期値セット
    this.beforeChangeStatus = this.orderData.harvest_status
    this.beforeChangeHarvestActualDate = this.orderData.harvest_actual_date
    // 等級の配列を作成
    const constantValue = JSON.parse(Local.getConstantValue()!)
    this.gradeList = constantValue.grades

    let type: number = parseInt(Local.getUserType()!)
    if (String(this.orderKey).indexOf('modal') !== -1 || type === userType.USER_TYPE_FARM_WORKER) {
      this.isActiveStatus = true
    }
  }

  private createDisplayDate (e: any) {
    const i = e.toString()
    const year = i.slice(0, 4)
    let month = i.slice(5, 7)
    const date = i.slice(8, 10)
    month = parseInt(month) - 1
    return new Date(year, month, date)
  }

  private displayValue (val: string|number) {
    return val !== null && val !== undefined ? val : '-'
  }

  private getGradeName (id: number) {
    for (let i in this.gradeList) {
      if (id === this.gradeList[i].grade_id) {
        return this.gradeList[i].grade_name
      }
    }
    return '-等級'
  }

  private getStatus (key: number) {
    switch (key) {
      case 0:
        return '未指示'

      case 1:
        return '保留'

      case 2:
        return '中止'

      case 3:
        return '収穫指示'

      case 4:
        return '収穫途上'

      case 5:
        return '収穫済み'

      default:
        break
    }
  }

  private judgeHarvestStatus () {
    if (this.orderData.harvest_status === harvestStatus.HARVESTE_INSTRUCTIONS ||
        this.orderData.harvest_status === harvestStatus.HARVESTED) {
      return false
    } else {
      return true
    }
  }

  private judgeHarvestActualDate (data: any) {
    if (this.orderData.harvest_status === harvestStatus.HARVESTE_INSTRUCTIONS ||
        this.orderData.harvest_status === harvestStatus.HARVESTED) {
      this.orderData.harvest_actual_date = data
      if (data === null || data === undefined) {
        return null
      } else {
        return this.createYYYYmmdd(data)
      }
    } else {
      this.orderData.harvest_actual_date = null
      return null
    }
  }

  /* 収穫実績日の変更を検知 */
  private harvestActualDateChange (data: any) {
    this.afterChangeHarvestActualDate = data
    this.afterChangeStatus = parseInt(this.orderData.harvest_status)

    const bodyData = {
      'harvest_status': this.afterChangeStatus,
      'harvest_actual_date': this.judgeHarvestActualDate(data),
      'time_stamp': this.orderData.time_stamp
    }
    this.changeTarget = '収穫実績日'

    this.updateStatus(this.orderData.planting_harvest_instruction_id, bodyData)
  }

  /* セレクトボックスの変更を検知 */
  private selectStatusChange () {
    this.afterChangeStatus = parseInt(this.orderData.harvest_status)
    this.afterChangeHarvestActualDate = this.orderData.harvest_actual_date
    this.orderData.harvest_status = this.beforeChangeStatus
    if (this.checkChangeStatus()) {
      const bodyData = {
        'harvest_status': this.afterChangeStatus,
        'harvest_actual_date': this.judgeHarvestActualDate(this.orderData.harvest_actual_date),
        'time_stamp': this.orderData.time_stamp
      }

      this.updateStatus(this.orderData.planting_harvest_instruction_id, bodyData)
    }
  }

  private checkChangeStatus () {
    this.changeTarget = '収穫ステータス'
    if ((this.beforeChangeStatus === harvestStatus.HARVESTE_INSTRUCTIONS ||
        this.beforeChangeStatus === harvestStatus.HARVESTED) &&
        this.orderData.harvest_actual_date !== null) {
      if (this.afterChangeStatus === harvestStatus.NOT_DIRECTED ||
          this.afterChangeStatus === harvestStatus.ON_HOLD ||
          this.afterChangeStatus === harvestStatus.CHANCEL ||
          this.afterChangeStatus === harvestStatus.HARVESTING) {
        this.$emit('show-status-change-modal', this.orderData.field_id)
        return false
      }
    }

    return true
  }

  private createYYYYmmdd (e: any) {
    if (e === null) {
      return e
    } else {
      if (String(e).length === 19) {
        e = this.createDisplayDate(e)
      }
      const year = String(e.getFullYear())
      const month = '0' + String(e.getMonth() + 1)
      const day = '0' + String(e.getDate())
      return parseInt(year + month.slice(-2) + day.slice(-2))
    }
  }

  private getBeforeStatus (status: number) {
    this.beforeChangeStatus = status
    this.beforeChangeHarvestActualDate = this.orderData.harvest_actual_date
  }

  /* 保留に変更 */
  private changeStatus () {
    this.orderData.harvest_status = harvestStatus.ON_HOLD

    const bodyData = {
      'harvest_status': this.orderData.harvest_status,
      'harvest_actual_date': this.judgeHarvestActualDate(this.orderData.harvest_actual_date),
      'time_stamp': this.orderData.time_stamp
    }
    this.changeTarget = '収穫ステータス'

    this.updateStatus(this.orderData.planting_harvest_instruction_id, bodyData)
  }

  /* ステータス変更API */
  private updateStatus (id: number, bodyData: any) {
    (async () => {
      const result = await FieldOrderEditApi.doUpdateStatus(id, bodyData)

      if (result.isOk()) {
        this.orderData.harvest_status = this.afterChangeStatus
        if (this.orderData.harvest_status === harvestStatus.HARVESTE_INSTRUCTIONS ||
          this.orderData.harvest_status === harvestStatus.HARVESTED) {
          this.orderData.harvest_actual_date = this.afterChangeHarvestActualDate
        } else {
          this.orderData.harvest_actual_date = null
        }
        this.beforeChangeStatus = this.orderData.harvest_status
        this.beforeChangeHarvestActualDate = this.orderData.harvest_actual_date
        this.orderData.time_stamp = result.getPayload().time_stamp
        Vue.prototype.$alert.toast({ text: this.changeTarget + 'を更新しました。', type: 0 })
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
        if (errorData.status_code === '409') {
          const data = {
            id: this.orderData.planting_harvest_instruction_id,
            status: this.beforeChangeStatus,
            date: this.beforeChangeHarvestActualDate
          }
          this.$emit('show-error409-modal', data)
        } else {
          if (this.changeTarget === '収穫ステータス') {
            this.orderData.harvest_status = this.beforeChangeStatus
          } else {
            this.orderData.harvest_actual_date = this.beforeChangeHarvestActualDate
          }
          this.$emit('show-error-info', this.changeTarget + '更新に失敗しました。')
        }
      }
    })()
  }

  private getRisk (key: number) {
    switch (key) {
      case 0:
        return 'リスクなし'

      case 1:
        return 'リスクあり'

      default:
        break
    }
  }

  public active () {
    this.isActive = !this.isActive
  }

  /* 全てのアコーディオンを開く */
  public allExpand (id: number) {
    let getAllToggles = document.getElementsByClassName('toggle-btn')
    let $el: HTMLElement = getAllToggles[id] as HTMLElement

    if (this.toggle) {
      // 閉じる
      let element: any = $el.parentElement
      if (element.getAttribute('aria-expanded') === 'false') {
        this.toggle = false
        return
      }
      $el.click()
      this.toggle = false
    } else {
      // 開く
      let element: any = $el.parentElement
      if (element.getAttribute('aria-expanded') === 'true') {
        this.toggle = true
        return
      }
      $el.click()
      this.toggle = true
    }
  }

  /* 全てのアコーディオンを閉じる */
  public allClose (id: number) {
    this.toggle = false
    let getAllToggles = document.getElementsByClassName('toggle-btn')
    let $el: HTMLElement = getAllToggles[id] as HTMLElement

    let element: any = $el.parentElement
    if (element.getAttribute('aria-expanded') !== 'false') {
      $el.click()
    }
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    if (num === null || num === undefined) {
      return '-'
    } else {
      return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }

  private displayFixedRisk (risk: any): string {
    return RiskFunction.displayFixedRisk(risk)
  }
  private displayOtherRisk (risk: any): string {
    return RiskFunction.displayOtherRisk(risk)
  }
}
